<app-nav-bar>
  <ul mobile class="nav-bar__mobile__items">
    <li class="nav-bar__mobile__item" data-testid="header-privacy-policy">
      <a target="_blank" href="https://www.rocketclose.com/privacy-policy" rel="noopener"
        >Privacy Policy</a
        >
      </li>
      <li class="nav-bar__mobile__item" data-testid="header-terms-of-use">
        <a target="_blank" href="https://www.rocketclose.com/terms-of-use" rel="noopener">Terms of Use</a>
      </li>
      <li class="nav-bar__mobile__item">
        <button (click)="logout()" data-testid="presign-logout">Logout</button>
      </li>
      @if (isWizard || isSigningRoom) {
        <li class="nav-bar__mobile__item">
          <button
            (click)="exitSigning()"
            data-testid="exit-signing-button"
            >
            Exit Signing
          </button>
        </li>
      }
      <li class="nav-bar__mobile__item">
        <app-support-phone-number-button></app-support-phone-number-button>
      </li>
    </ul>

    <app-support-phone-number-button></app-support-phone-number-button>

    <app-menu
      [isPrivacyPolicyButtonEnabled]="true"
      [isTermsOfUseButtonEnabled]="true"
      [isPreSignLogoutButtonEnabled]="true">
    </app-menu>
    @if (isWizard || isSigningRoom) {
      <button
        mat-button
        (click)="exitSigning()"
        tabIndex="4"
        data-testid="exit-signing-button"
        >
        <mat-icon>logout</mat-icon>
        Exit Signing
      </button>
    }
  </app-nav-bar>
